"use client";

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { LayoutDashboard, Calendar, Tag, Settings, FileText, Activity, Zap, X } from 'lucide-react';
import styles from './Sidebar.module.css';
import clsx from 'clsx';
import { useLanguage } from '@/lib/i18n/LanguageContext';
import { useMobileNav } from '@/lib/ui/MobileNavContext';

export default function Sidebar() {
    const pathname = usePathname();
    const { t } = useLanguage();
    const { isOpen, close } = useMobileNav();

    const navItems = [
        { name: t('nav.today'), href: '/', icon: LayoutDashboard },
        { name: t('nav.calendar'), href: '/calendar', icon: Calendar },
        { name: t('nav.rates'), href: '/rates', icon: Tag },
        { name: t('nav.automation'), href: '/automation', icon: Zap },
        { name: t('nav.audit'), href: '/audit', icon: FileText },
        { name: t('nav.settings'), href: '/settings', icon: Settings },
    ];

    return (
        <>
            {/* Mobile Overlay */}
            <div
                className={clsx(styles.overlay, isOpen && styles.overlayOpen)}
                onClick={close}
            />

            <aside className={clsx(styles.sidebar, isOpen && styles.open)}>
                <div className={styles.logo}>
                    <Activity className={styles.logoIcon} />
                    <span className={styles.logoText}>SynthHotel</span>
                    <button className={styles.closeBtn} onClick={close}>
                        <X size={20} />
                    </button>
                </div>

                <nav className={styles.nav}>
                    {navItems.map((item) => {
                        const isActive = pathname === item.href;
                        const Icon = item.icon;

                        return (
                            <Link
                                key={item.href}
                                href={item.href}
                                className={clsx(styles.navItem, isActive && styles.active)}
                            >
                                <Icon size={20} className={styles.icon} />
                                <span>{item.name}</span>
                                {isActive && <div className={styles.activeIndicator} />}
                            </Link>
                        );
                    })}
                </nav>

                {/* Mobile Only Controls */}
                <div className={styles.mobileControls}>
                    <div className={styles.controlRow}>
                        <Link href="/settings" className={styles.controlBtn}>
                            <Settings size={18} /> Settings
                        </Link>
                        {/* More controls can be added here or just link to settings page for complexity reduction */}
                    </div>
                </div>

                <div className={styles.footer}>
                    <div className={styles.hotelBadge}>
                        <div className={styles.hotelName}>SynthHotel Berlin</div>
                        <div className={styles.hotelStatus}>{t('sidebar.status')}</div>
                    </div>

                    <div className={styles.copyright}>
                        © 2026 SynthHotel · Created by <a href="https://alphasynthai.com" target="_blank" rel="noopener noreferrer" className={styles.copyrightLink}>AlphaSynth AI</a>
                    </div>
                </div>
            </aside>
        </>
    );
}
